module.exports = __webpack_public_path__ + "img/renaissance_in_action_2.071918d8.jpg";